module.exports = __webpack_public_path__ + "site/img/63.07466ed7.jpg";